module.exports = __webpack_public_path__ + "static/media/sub-gps.25a6a42c.svg";